module.exports = __webpack_public_path__ + "img/closed-captioning-slash.abd4e626.svg";